/**
 * Copy table for the typed chat-error codes emitted by the backend classifier
 * (backend/src/utils/errorClassifier.js). The backend always populates a
 * user-safe `error` string on the wire; this table lets the frontend override
 * that copy per code without a backend deploy.
 *
 * Keep these keys in sync with backend's classifyError code vocabulary, except
 * AUTH_EXPIRED, which is minted by the frontend polling transport.
 */
export const ERROR_COPY = {
  TRANSIENT_OVERLOAD: "We're experiencing high demand. Please try again in a moment.",
  RATE_LIMITED: "We've hit a rate limit. Please wait a moment and try again.",
  TIMEOUT: 'This is taking longer than expected. Please try again.',
  AUTH_EXPIRED: 'Your session has expired — please log in again.',
  INVALID_REQUEST: 'Sorry. I ran into an issue.',
  UNKNOWN: 'Sorry. I ran into an issue.'
};

/**
 * Resolve the banner copy for a given classification. Preference order:
 *   1. Frontend copy table override (ERROR_COPY[code])
 *   2. Server-provided userMessage (already user-safe; see backend classifier)
 *   3. Generic UNKNOWN fallback
 *
 * @param {{ errorCode?: string, userMessage?: string|null }} params
 * @returns {string}
 */
export function resolveErrorCopy({ errorCode, userMessage } = {}) {
  if (errorCode && ERROR_COPY[errorCode]) return ERROR_COPY[errorCode];
  if (typeof userMessage === 'string' && userMessage) return userMessage;
  return ERROR_COPY.UNKNOWN;
}
